import { BuiltInComponents } from 'craft/constants';
import { CONDITIONAL_ID } from 'craft/containers/Conditionals';
import { Conditional, SerializedNodeTree } from 'craft/types';

export const createConditionalFlowStep = (name: string, conditionalDefinition: Conditional) =>
  (({
    rootNodeId: '3bBlLh',
    nodes: {
      '3bBlLh': {
        type: {
          resolvedName: BuiltInComponents.ConditionalViewOption,
        },
        props: {
          name,
        },
        name: 'ConditionalViewOption',
        custom: {
          conditionals: {
            [CONDITIONAL_ID]: conditionalDefinition,
          },
        },
      },
    },
  } as unknown) as SerializedNodeTree);

export const createEveryoneConditionalFlowStep = () =>
  (({
    rootNodeId: '3bBlLh',
    nodes: {
      '3bBlLh': {
        type: {
          resolvedName: BuiltInComponents.ConditionalViewOption,
        },
        props: {
          name: 'Everyone',
        },
        name: 'ConditionalViewOption',
      },
    },
  } as unknown) as SerializedNodeTree);
